import React from 'react';
import { Text, useBreakpointValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ 
    size = 'default', 
    color = 'brand.text', 
    showHover = true,
    onClick, 
}) => {
    const navigate = useNavigate();

    // Responsive logo sizes
    const logoSize = useBreakpointValue({
        base: size === 'small' ? '1.5rem' : size === 'large' ? '2.5rem' : '1.75rem',
        md: size === 'small' ? '1.8rem' : size === 'large' ? '3rem' : '2.2rem',
        lg: size === 'small' ? '1.8rem' : size === 'large' ? '3rem' : '2.2rem',
    });

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            navigate('/');
        }
    };

    return (
        <Text
            fontFamily="'Cinzel Decorative', serif"
            fontWeight="medium"
            color={color}
            fontSize={logoSize}
            userSelect="none"
            cursor="pointer"
            onClick={handleClick}
            transition="all 0.2s ease"
            _hover={showHover ? { 
                color: 'brand.main',
                transform: 'scale(1.02)',
            } : {}}
        >
            SilviaHProst
        </Text>
    );
};

export default Logo; 